module.exports = __webpack_public_path__ + "media/images/application/template/icon--link-internal-99501661d02ebbbd9c19b209fe52a777.svg";